import { render } from "./AddNewLanguage.vue?vue&type=template&id=407dfd7a&scoped=true"
import script from "./AddNewLanguage.vue?vue&type=script&lang=js"
export * from "./AddNewLanguage.vue?vue&type=script&lang=js"

import "./AddNewLanguage.vue?vue&type=style&index=0&id=407dfd7a&scoped=true&lang=stylus"
script.render = render
script.__scopeId = "data-v-407dfd7a"

export default script